import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import { GetStudyLines } from '../helper/apiHelper';

export const useStudyLines = () => {
  return useQuery({
    queryKey: QUERY_KEYS.STUDY_LINES,
    queryFn: () => GetStudyLines(),
  });
};
